import React, { useState, useEffect, useRef } from "react";
import Autoplay from 'embla-carousel-autoplay';
import CardServicosCompacto from "./cardServicosCompacto";
import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
    CarouselButtonsMobile
} from "./carousel";

const servicosData = [
    {
        icon: "../assets/servicos/duracao_icon.svg",
        iconHover: "../assets/servicos/duracao_icon.svg",
        title: (
            <>
                Duração:
                <br />6 meses
            </>
        ),
        text: "",
        glowColor: "#A800E4",
        url: "",
    },
    {
        icon: "../assets/servicos/desenho_icon.svg",
        iconHover: "../assets/servicos/desenho_icon.svg",
        title: "Desenho do programa",
        text: "(trilhas, processo seletivo, avaliação)",
        glowColor: "#A800E4",
        url: "",
    },
    {
        icon: "../assets/servicos/universidades_icon.svg",
        iconHover: "../assets/servicos/universidades_icon.svg",
        title: "Seleção das universidades",
        text: <></>,
        glowColor: "#A800E4",
        url: "",
    },
    {
        icon: "../assets/servicos/selecao_icon.svg",
        iconHover: "../assets/servicos/selecao_icon.svg",
        title: "Seleção dos profissionais",
        text: <></>,
        glowColor: "#A800E4",
        url: "",
    },
    {
        icon: "../assets/servicos/imersao_icon.svg",
        iconHover: "../assets/servicos/imersao_icon.svg",
        title: "Capacitação técnica com desenvolvimento de soft e hard-skills",
        text: <></>,
        glowColor: "#A800E4",
        url: "",
    },
    {
        icon: "../assets/servicos/imersao2_icon.svg",
        iconHover: "../assets/servicos/imersao2_icon.svg",
        title: "Imersão prática interna",
        text: "(3 meses)",
        glowColor: "#A800E4",
        url: "",
    },
    {
        icon: "../assets/servicos/imersao_icon.svg",
        iconHover: "../assets/servicos/imersao.icon.svg",
        title: "Imersão prática no cliente",
        text: "(3 meses)",
        glowColor: "#A800E4",
        url: "",
    },
];

export default function Programa() {
    const [api, setApi] = useState(null);
    const [current, setCurrent] = useState(0);
    const [count, setCount] = useState(0);
    const { openModal } = useModal();
    const scrollRef = useRef(null);
    
    // Calculate number of pages based on items and visible items per page
    const itemsPerPage = 3; // Number of items visible at once
    const totalPages = Math.ceil(servicosData.length / itemsPerPage);
    
    useEffect(() => {
        if (!api) return;
        
        // Update current slide when carousel changes
        const onSelect = () => {
            setCurrent(api.selectedScrollSnap());
        };
        
        api.on("select", onSelect);
        setCount(api.scrollSnapList().length);
        setCurrent(api.selectedScrollSnap());
        
        return () => {
            api.off("select", onSelect);
        };
    }, [api]);
    
    // Function to navigate to a specific slide
    const goToSlide = (index) => {
        if (api) {
            api.scrollTo(index);
        }
    };
    
    return (
        <section className="bg-[url(../assets/cover-programa.png)] bg-cover py-12 md:py-20 px-4 md:px-24 text-white">
            <div className="container mx-auto">
                <h2 className="font-inter-regular text-4xl md:text-[60px] text-center">
                    O Programa
                </h2>
                
                {/* Desktop view - only visible on md screens and up */}
                <div className="hidden md:block max-w-6xl mx-auto mt-8">
                    <Carousel setApi={setApi}>
                        <CarouselContent className="items-center gap-0">
                            {servicosData.map((servico, index) => (
                                <CarouselItem
                                    key={index}
                                    className="basis-1/3 xl:basis-1/4 h-[340px] flex items-center"
                                >
                                    <CardServicosCompacto
                                        {...servico}
                                        width={250}
                                        height={250}
                                    />
                                </CarouselItem>
                            ))}
                        </CarouselContent>
                        <CarouselNext className="hover:cursor-pointer" />
                        <CarouselPrevious className="hover:cursor-pointer" />
                    </Carousel>
                    
                    {/* Indicators - similar to Banner component - desktop only */}
                    <div className="flex justify-center gap-2 mt-4">
                        {Array.from({ length: count }).map((_, index) => (
                            <button
                                key={index}
                                onClick={() => goToSlide(index)}
                                className={`${current === index ? 'w-[24px]' : 'w-[8px]'} h-[8px] rounded-full cursor-pointer transition-all duration-300 ${current === index ? 'bg-transparent border border-white' : 'bg-white'}`}
                                aria-label={`Go to slide ${index + 1}`}
                            />
                        ))}
                    </div>
                </div>
                
                {/* Mobile view - only visible on small screens */}
                <div ref={scrollRef} className="md:hidden mt-8">
                    <Carousel
                        plugins={[
                            Autoplay({
                                delay: 4000,
                            }),
                        ]}
                        className="overflow-visible"
                    >
                        <CarouselContent className="py-2">
                            {servicosData.map((servico, index) => (
                                <CarouselItem key={index}>
                                    <div className="flex justify-center w-full">
                                        <CardServicosCompacto
                                            {...servico}
                                            className="mx-auto scale-90"
                                            width="350"
                                            height="230"
                                        />
                                    </div>
                                </CarouselItem>
                            ))}
                        </CarouselContent>
                        <CarouselButtonsMobile />
                    </Carousel>
                </div>
                
                {/* CTA Button */}
                <div className="flex justify-center mt-8 md:mt-16">
                    <button 
                        onClick={() => openModal(<FormularioRD />)}
                        className="font-inter-bold bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] rounded-full py-3 px-8 text-white font-medium hover:scale-105 transition-transform duration-300 cursor-pointer"
                    >
                        Faça parte do Programa
                    </button>
                </div>
            </div>
        </section>
    );
}
